module.exports = __webpack_public_path__ + "static/img/sspg_01.7634d58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sspg/sspg_01.jpg
// module id = T0H/
// module chunks = 1